import { render, staticRenderFns } from "./PhoneFramePreview.vue?vue&type=template&id=4a4f34dc&"
import script from "./PhoneFramePreview.vue?vue&type=script&lang=js&"
export * from "./PhoneFramePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports